import React, { useState } from 'react';

const UnitForm = () => {
  const [noOfUnit, setNoOfUnit] = useState(0);

  const handleNoOfUnit = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value >= 0) {
      setNoOfUnit(value);
    }
  };

  const incrementUnit = () => {
    setNoOfUnit((prev) => prev + 1);
  };

  const decrementUnit = () => {
    setNoOfUnit((prev) => (prev > 0 ? prev - 1 : 0));
  };

  return (
    <div>
      <div className="input-box form-floating" style={{ position: 'relative', paddingTop: '5px' }}>
        <input
          type="number"
          placeholder=""
          className="form-control input-text form-control-sm mt-1"
          id="noOfUnit"
          name="noOfUnit"
          maxLength="5"
          min="0"
          value={noOfUnit}
          onChange={handleNoOfUnit}
        />
        <i
          className="fa-solid fa-minus text-secondary"
          style={{
            position: 'absolute',
            right: '50px',
            top: '60%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
          onClick={decrementUnit}
        ></i>
        <i
          className="fa-solid fa-plus text-secondary"
          style={{
            position: 'absolute',
            right: '20px',
            top: '60%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
          onClick={incrementUnit}
        ></i>
        <label htmlFor="floatingInput" className="m-0">
          No of Unit*
        </label>
      </div>

      {/* Show unit sections only if noOfUnit >= 2 */}
      {noOfUnit >= 2 &&
        Array.from({ length: noOfUnit }, (_, index) => (
          <div key={index} className="border mt-2">
            <h6 className="p-2">Unit {index + 1}</h6>

            <div className="input-box form-floating">
              <input
                type="tel"
                placeholder=""
                className="form-control input-text form-control-sm mt-1"
                id={`floor${index}`}
                name={`floor${index}`}
              />
              <label htmlFor={`floor${index}`} className="mt-2">
                Floor
              </label>
            </div>

            <div className="input-box form-floating">
              <input
                type="tel"
                placeholder=""
                className="form-control input-text form-control-sm mt-1"
                id={`area${index}`}
                name={`area${index}`}
              />
              <label htmlFor={`area${index}`} className="mt-2">
                Carpet Area
              </label>
            </div>

            <div className="input-box form-floating">
              <input
                type="tel"
                placeholder=""
                className="form-control input-text form-control-sm mt-1"
                id={`empCount${index}`}
                name={`empCount${index}`}
              />
              <label htmlFor={`empCount${index}`} className="mt-2">
                Employee Count
              </label>
            </div>
          </div>
        ))}
    </div>
  );
};

export default UnitForm;
